import { Backdrop, Box, Fade, Grid, Modal, Typography } from "@mui/material";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  justifyContent: "center",
};

export const ModalNoDel = ({ open, handleClose, items }) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              sx={{ p: 0, mb: 2, pr: 1 }}
              className="center_item"
            >
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Formato aún en uso
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ p: 0, mb: 2, pr: 1 }}
              className="center_item"
            >
              <span>
                El formato aun sigue en uso en rutas de parte, para eliminar
                primero reemplacelo en las siguientes partes:
              </span>
            </Grid>
            <div style={{ maxHeight: 300, overflowY: "scroll", width: '100%' }}>
              {(items ?? []).map((item) => (
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', justifyContent: 'left', mb:1}}
                >
                  <span>
                    {item?.part_codigoentrada} - {item?.part_nombre}
                  </span>
                </Grid>
              ))}
            </div>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};
